import React, { useEffect } from "react";
import MainHeader from "../../components/mainheader";
import MainContainer from "../../components/maincontainer";
import Main from "../../assets/main.svg";
import SubCat from "../../assets/subcat.svg";
import Catorder from "../../assets/catord.svg";
import Import from "../../assets/import.svg";
import Manage from "../../assets/manage.svg";
import MathQuizTable from "../../components/tables/math-quiz-table";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateCategory from "../../components/modals/create-category";
// import CreateSubCategory from "../../components/modals/create-sub-category";
import { useSelector, useDispatch } from "react-redux";
import {
	LoadMore,
	LoadingLoader,
	MainPaginate,
} from "../../components/buttons/button";
import { manageMathQuiz } from "../../data/Reducers/MathQuizReducer";

const MathQuiz = () => {
	const [modal, setModal] = useState(""),
		navigate = useNavigate();
	const handleClose = () => {
		setModal("");
	};
	const Arr = [
		{
			title: "Main category",
			img: Main,
			bg: "#F7F8FF",
			action: () => setModal("create-category"),
		},
		{
			title: "sub category",
			img: SubCat,
			bg: "#F7FFF7",
			action: () => setModal("create-sub-category"),
		},
		{
			title: "category order",
			img: Catorder,
			bg: "#FCEEFF",
			action: () => navigate("/category-order"),
		},
		{
			title: "Create Questions",
			img: Manage,
			bg: "#F4FFF1",
			action: () => navigate("/math-quiz/create-question"),
		},
		{
			title: "import questions",
			img: Import,
			bg: "#F7F8FF",
			action: () =>
				navigate("/bulk-upload", {
					state: {
						type: "mathQuiz",
						title: "Math Mania",
						subTitle: "Create Math Mania",
					},
				}),
		},
	];
	const Headers = ["ID", "image", "language", "questions", "answer", "actions"];
	const tableData = [
		{
			id: "25",
			language: "English",
			questions: "Lorem ipsum dolor sit amet",
			answer: "Microsoft",
		},
		{
			id: "25",
			language: "English",
			questions: "Lorem ipsum dolor sit amet",
			answer: "Microsoft",
		},
		{
			id: "25",
			language: "English",
			questions: "Lorem ipsum dolor sit amet",
			answer: "Microsoft",
		},
		{
			id: "25",
			language: "English",
			questions: "Lorem ipsum dolor sit amet",
			answer: "Microsoft",
		},
		{
			id: "25",
			language: "English",
			questions: "Lorem ipsum dolor sit amet",
			answer: "Microsoft",
		},
	];

	let { mathQuiz } = useSelector(s => s),
		[data, setData] = useState(null),
		dispatch = useDispatch();

	useEffect(() => {
		setData(mathQuiz?.data);
	}, [mathQuiz?.data]);

	useEffect(() => {
		dispatch(manageMathQuiz("get", null));
	}, [dispatch]);

	let [range] = useState(10),
		[page, setPage] = useState(1),
		[loading, setLoading] = useState(null);

	const [itemOffset, setItemOffset] = useState(0);
	const endOffset = itemOffset + range;

	if (!data && !mathQuiz?.data) return <LoadingLoader />;

	const currentItems = data?.docs?.slice(itemOffset, endOffset);
	const pageCount = Math.ceil(data?.docs?.length / range);

	const handlePageClick = event => {
			const newOffset = (event.selected * range) % data?.docs?.length;
			setItemOffset(newOffset);
			setPage(1 + event?.selected);
		},
		handleLoadMore = async () => {
			setLoading("loadmore");
			let datum = { limit: data?.limit * data?.nextPage };
			await dispatch(manageMathQuiz("get", datum));
			setLoading(false);
		};

	return (
		<div>
			<MainHeader text={"Math Mania"} />
			<MainContainer>
				<h2 className="tw-text-xl tw-text-main tw-font-normal work">
					Math Mania
				</h2>
				<div className="tw-mt-8 tw-grid lg:tw-grid-cols-4 md:tw-grid-cols-2 tw-gap-6">
					{Arr.map((item, i) => (
						<div
							key={i}
							onClick={item.action}
							style={{
								background: item.bg,
							}}
							className={`myShadow2 tw-rounded-md tw-cursor-pointer tw-flex tw-justify-center tw-items-center tw-h-28`}>
							<div>
								<img src={item?.img} alt={item?.title} className="tw-mx-auto" />
								<h4 className="tw-text-base sansation tw-mt-2 tw-font-bold tw-text-center tw-text-main tw-capitalize">
									{item.title}
								</h4>
							</div>
						</div>
					))}
				</div>
				<div className="tw-mt-10">
					<MathQuizTable data={currentItems || tableData} headers={Headers} />
					<div className="tw-mt-4 tw-flex tw-justify-center">
						<LoadMore
							next={page === pageCount && data?.hasNextPage}
							loading={loading === "loadmore"}
							handleLoadMore={handleLoadMore}
						/>
					</div>
					<div className="tw-mt-4 tw-flex tw-justify-center">
						{/* <Pagination /> */}
						<MainPaginate
							pageCount={pageCount}
							handlePageClick={handlePageClick}
						/>
					</div>
				</div>
			</MainContainer>
			{modal === "create-category" && (
				<CreateCategory handleClose={handleClose} subType="mathQuiz" />
			)}
			{modal === "create-sub-category" && (
				<CreateCategory
					handleClose={handleClose}
					type="sub category"
					subType="mathQuiz"
				/>
				// <CreateSubCategory handleClose={handleClose} />
			)}
		</div>
	);
};

export default MathQuiz;
